import{createTheme as e}from"@mui/material/styles";import{base as t}from"./base";const a=e({...t,palette:{...t.palette,mode:"light",primary:{light:"#D6EFF9",main:"#269AE0",dark:"#157DBB"}}});export{a as light};
//# sourceMappingURL=light.js.map
